import { useLocalStorage } from '~/src/common/hooks/useLocalStorage';
import { isString } from '~/src/common/utils/guards';
import { GetGroceryTerms200ItemsItem } from '~/src/queries/api-ecom/generated/api-ecom.schemas';

export const isArrayOfTerm = (value: unknown): value is GetGroceryTerms200ItemsItem[] => {
  return (
    Array.isArray(value) &&
    value.every(
      item => typeof item === 'object' && item !== null && 'term' in item && 'type' in item,
    )
  );
};

export const GROCERY_LIST_KEY = 'keplr.grocery-list';
export const GROCERY_TERMS_KEY = 'keplr.grocery-terms';

export const useGroceryListStore = () => useLocalStorage(GROCERY_LIST_KEY, isString);
export const useGroceryTermsStore = () => useLocalStorage(GROCERY_TERMS_KEY, isArrayOfTerm);
